import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

const Redirect = ({ to }) => { const { search } = useLocation(); return <Navigate to={to + search} replace />; };
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { PublicLayout } from "./components/PublicLayout";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import Platforms from "./pages/Platforms";
import About from "./pages/About";
import Publications from "./pages/Publications";
import Academy from "./pages/Academy";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Login from "./pages/admin/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import PostsList from "./pages/admin/PostsList";
import PostEditor from "./pages/admin/PostEditor";
import PublicationsManager from "./pages/admin/PublicationsManager";
import CaseStudies from "./pages/admin/CaseStudies";
import LeadsInbox from "./pages/admin/LeadsInbox";
import Triage from "./pages/admin/Triage";
import Settings from "./pages/admin/Settings";
import SeoSettings from "./pages/admin/SeoSettings";
import Analytics from "./pages/admin/Analytics";
import EvidenceFinder from "./pages/admin/EvidenceFinder";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services/:slug" element={<ServicePage />} />
              <Route path="/platforms" element={<Platforms />} />
              <Route path="/us-market-access" element={<Redirect to="/services/us-market-access" />} />
              <Route path="/eu-jca" element={<Redirect to="/services/eu-jca" />} />
              <Route path="/jca" element={<Redirect to="/services/eu-jca" />} />
              <Route path="/social-media-listening" element={<Redirect to="/services/social-listening" />} />
              <Route path="/patient-voice" element={<Redirect to="/services/social-listening" />} />
              <Route path="/hcp-voice" element={<Redirect to="/services/hcp-intelligence" />} />
              <Route path="/heor" element={<Redirect to="/services/heor" />} />
              <Route path="/rwe" element={<Redirect to="/services/rwe" />} />
              <Route path="/research/rwe" element={<Redirect to="/services/rwe" />} />
              <Route path="/medical-affairs" element={<Redirect to="/services/medical-affairs" />} />
              <Route path="/competitive-intelligence" element={<Redirect to="/services/competitive-intelligence" />} />
              <Route path="/advanced-analytics" element={<Redirect to="/services/advanced-analytics" />} />
              <Route path="/scientific-communications" element={<Redirect to="/services/scientific-communications" />} />
              <Route path="/about-us" element={<Redirect to="/about" />} />
              <Route path="/about" element={<About />} />
              <Route path="/publications" element={<Publications />} />
              <Route path="/academy" element={<Academy />} />
              <Route path="/heor-certification" element={<Redirect to="/academy" />} />
              <Route path="/blog/*" element={<Redirect to="/" />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/careers" element={<Careers />} />
            </Route>
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="posts" element={<PostsList />} />
              <Route path="posts/:id" element={<PostEditor />} />
              <Route path="publications" element={<PublicationsManager />} />
              <Route path="case-studies" element={<CaseStudies />} />
              <Route path="leads" element={<LeadsInbox />} />
              <Route path="triage" element={<Triage />} />
              <Route path="settings" element={<Settings />} />
              <Route path="seo" element={<SeoSettings />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="evidence" element={<EvidenceFinder />} />
            </Route>
            <Route path="*" element={<Redirect to="/" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
